import React from 'react';
import CtaForm from './CtaForm';

const CtafromSection = (props) => {
    return (
        <section className={"" +props.hclass}>
            <div className="container">
                <div className="cta_wrap">
                    <div className="content">
                        <h2>Your Path to Peak Wellness Starts Here</h2>
                        <p>Take the first step towards amplifying your body's natural healing power at Amped Therapeutics</p>
                    </div>
                    <CtaForm/>
                </div>
            </div>
        </section>
    );
};

export default CtafromSection;